import * as Result from './Result'
import {Effect, effect} from '@mazechazer/redux-loop'
import {decodeJson} from './DecodeHelper'
import * as HttpRequest from './HttpRequest'
import {saveAs} from 'file-saver'
import {Decoder} from 'json-bouncer'
import {Dictionary} from './Dictionary'

export function sendRequest<Action>(
    mapAction: (result: Result.Result<HttpError, string>) => Action,
    httpRequest: HttpRequest.HttpRequest,
): Effect<Action> {
    return effect(() => {
        return fetch(HttpRequest.toRequest(httpRequest))
            .then(response => response.text()
                .then(
                    (value: string): Result.Result<HttpError, string> => {
                        if (response.ok) {
                            return {type: 'Ok', value}
                        } else {
                            return {
                                type: 'Err',
                                error: {
                                    type: 'BadResponse',
                                    status: response.status,
                                },
                            }
                        }
                    }))
            .catch(error => ({
                type: 'Err',
                error: {
                    type: 'NetworkError',
                    message: error.message,
                },
            }))
            .then(mapAction)
    })
}

export function sendDownloadRequest<Action>(
    mapAction: (result: Result.Result<HttpError, null>) => Action,
    httpRequest: HttpRequest.HttpRequest,
    filename: string,
): Effect<Action> {
    return effect(() => {
        return fetch(HttpRequest.toRequest(httpRequest))
            .then(response => response.blob()
                .then((blob): Result.Result<HttpError, null> => {
                    if (response.ok) {
                        saveAs(blob, filename, true)
                        return {
                            type: 'Ok',
                            value: null,
                        }
                    } else {
                        return {
                            type: 'Err',
                            error: {
                                type: 'BadResponse',
                                status: response.status,
                            }
                        }
                    }
                }))
            .catch(error => ({
                type: 'Err',
                error: {
                    type: 'NetworkError',
                    message: error.message,
                }
            }))
            .then(mapAction)
    })
}

export type HttpError = NetworkError | BadResponse | BadPayload

export interface NetworkError {
    type: 'NetworkError'
    message: string
}

export interface BadResponse {
    type: 'BadResponse'
    status: number
}

export interface BadPayload {
    type: 'BadPayload'
    message: string
}

export function decodeHttpResponse<T>(
    decoder: Decoder<T>,
    result: Result.Result<HttpError, string>,
): Result.Result<HttpError, T> {
    return Result.andThen(
        response =>
            Result.mapError(
                (message): HttpError => ({
                    type: 'BadPayload',
                    message,
                }),
                decodeJson(decoder, response),
            ),
        result,
    )
}

export function buildUrl(
    path: string,
    queryParams: Dictionary<string>,
): string {
    const queryString =
        Object
            .keys(queryParams)
            .map(key =>
                `${encodeURIComponent(key)}=${encodeURIComponent(queryParams[key])}`)
            .join('&')
    return queryString !== '' ? `${path}?${queryString}` : path
}

export function httpErrorToMessage(error: HttpError): string {
    switch (error.type) {
        case 'NetworkError':
            return `Netzwerkfehler: ${error.message}`
        case 'BadResponse':
            return `Fehlerhafte Antwort: ${error.status}`
        case 'BadPayload':
            return `Die Daten vom Server konnten nicht verarbeitet werden: ${error.message}`
    }
}

export function tokenExpired<T>(result: Result.Result<HttpError, T>): boolean {
    return (
        result.type === 'Err' &&
        result.error.type === 'BadResponse' &&
        result.error.status === 403)
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Data/Http.ts